import React, { Fragment, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import FolderForm from '../FolderForm';

const AddFolderControl = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Fragment>
      <Button variant="primary" onClick={handleShow}>
        Add folder
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create new folder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FolderForm onSubmit={handleClose} />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default AddFolderControl;
